/* Add a wrapper around all select elements */
jQuery('select').not('.listbox').wrap('<div class="select-wrapper" />');
